import React, {
    useState,
    useContext
  } from "react";
  import {
    withRouter
  } from "react-router";
  import {
    makeStyles
  } from "@material-ui/core/styles";
  import TextField from "@material-ui/core/TextField";
  import Select from '@material-ui/core/Select';
  import InputLabel from '@material-ui/core/InputLabel';
  import MenuItem from '@material-ui/core/MenuItem';
  import Grid from "@material-ui/core/Grid";
  import Paper from "@material-ui/core/Paper";
  import Typography from "@material-ui/core/Typography";
  import Button from "@material-ui/core/Button";
  import InputAdornment from "@material-ui/core/InputAdornment";
  import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
  import CircularProgress from "@material-ui/core/CircularProgress";
  import AlertMui from "../core/AlertMui";
  import ModalMui from "../core/ModalMui";
  import TermsOfUseMui from "../core/TermsOfUseMui";
  
  import AlertContext from "../../context/alert/alertContext";
  import ModalContext from "../../context/modal/modalContext";
  import PortalContext from "../../context/portal/portalContext";
  import AuthContext from "../../context/authentication/authContext";
  import useMediaQuery from "../../hooks/useMediaQuery";
  
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "553px",
    },
    paper: {
      padding: theme.spacing(2),
      color: theme.palette.text.secondary,
      marginTop: "20px",
      marginLeft: "20px",
    },
    typography: {
      padding: theme.spacing(3),
      fontSize: "22px",
    },
    form: {
      marginTop: theme.spacing(1),
    },
    contentSubmit: {
      margin: theme.spacing(3, 0, 2),
      textAlign: "center",
    },
  }));
  
  const TellAFriend = (props) => {
    const alertContext = useContext(AlertContext);
    const {
      alert,
      showAlert /* message */
    } = alertContext;
    const authContext = useContext(AuthContext);
    const { user, closeSession, hasToChange } = authContext;
    const portalContext = useContext(PortalContext);
    const { data } = portalContext;
    const modalContext = useContext(ModalContext);
    const { modalShow, showModal, closeModal } = modalContext;
    const [modalContent, setModalContent] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    /* useEffect(() => {
       if (message) {
        showAlert(message.msg, message.category);
      }
    }, [message]) */

    const {
      tellAFriend
    } = authContext;
    
    const [tellAFriendForm, setTellAFriendForm] = useState({
      referredCustomerRut: "",     
      referredCustomerName: "",
      referredCustomerResponsible: "",
      referredCustomerMail: "",
      referredCustomerPhone: "",
      referredCustomerAddress: ""
    });
  
    const [loading, setLoading] = useState(false);

    const {
        referredCustomerRut,
        referredCustomerName,
        referredCustomerResponsible,
        referredCustomerMail,
        referredCustomerPhone,
        referredCustomerAddress
    } = tellAFriendForm;
  
    const classes = useStyles();
    const isMobile = useMediaQuery("max-width", 600);
  

  
  
    const onChange = (e) => {
        setTellAFriendForm({
        ...tellAFriendForm,
        [e.target.name]: e.target.value,
      });
    };
  
    
    const onSubmit = async (e) => {
      setLoading(true);
      e.preventDefault();
  
      try {
        const response = await tellAFriend({
          referredCustomerRut: referredCustomerRut,
          referredCustomerName: referredCustomerName,
          referredCustomerResponsible: referredCustomerResponsible,
          referredCustomerMail: referredCustomerMail,
          referredCustomerPhone: referredCustomerPhone,
          referredCustomerAddress: referredCustomerAddress,
          
              customerRut: data.taxPayerInfo.rut
        });
  
        if (response.responseCode === 0) {
          showAlert("Gracias por tu referencia. Serás redirigido a la pantalla principal", "success");
          setTimeout(function(){ window.location.href = "/app/home" }, 3000);
        } else {
          showAlert(response.responseMessage, "error");
        }
      } catch (error) {
        //console.log(error);
        showAlert("Ha ocurrido un error inesperado", "error");
      }
  
      setLoading(false);
    };
  
    return (
      <div className={classes.root}>
        <ModalMui
          modalShow={modalShow}
          showModal={showModal}
          closeModal={closeModal}
          modalTitle={modalTitle}
        >
          {modalContent}
        </ModalMui>
        <Grid item xs={12}>
          <Grid item xs={12} >
            <Typography className={classes.typography}> Referir nuevo comercio</Typography>
            <TextField margin="normal"
                fullWidth id="referredCustomerRut"
                label="Rut de la persona/empresa a la que quiere referir"
                name="referredCustomerRut"
                type="text"
                autoFocus InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerRut
                }
                onChange={
                  onChange
                }
              /> 
            <TextField margin="normal"
                fullWidth id="referredCustomerName"
                label="Nombre de la persona/empresa a la que quiere referir"
                name="referredCustomerName"
                type="text"
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerName
                }
                onChange={
                  onChange
                }
              /> 
            <TextField margin="normal"
                fullWidth id="referredCustomerMail"
                label="Mail de la persona/empresa a la que quiere referir"
                name="referredCustomerMail"
                type="mail"
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerMail
                }
                onChange={
                  onChange
                }
              /> 
            <TextField margin="normal"
                fullWidth id="referredCustomerPhone"
                label="Teléfono de la persona/empresa a la que quiere referir"
                name="referredCustomerPhone"
                type="text"
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerPhone
                }
                onChange={
                  onChange
                }
              /> 
            <TextField margin="normal"
                fullWidth id="referredCustomerResponsible"
                label="Nombre del responsable (opcional)"
                name="referredCustomerResponsible"
                type="text"
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerResponsible
                }
                onChange={
                  onChange
                }
              /> 
            <TextField margin="normal"
                fullWidth id="referredCustomerAddress"
                label="Dirección del cliente a referir"
                name="referredCustomerAddress"
                type="text"
                multiline
                rowsMax={5}
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }                
                value={
                    referredCustomerAddress
                }
                onChange={
                  onChange
                }
              /> 
            <Paper className={classes.paper} >
              <form className={
                classes.form
              }
                style={{
                  width: !isMobile ? "30%" : "100%"
                }
                }
                noValidate onSubmit={
                  onSubmit
                } >
                
                {
                  alert && < AlertMui message={
                    alert.msg
                  }
                    type={
                      alert.category
                    }
                  />} <Grid className={
                    classes.contentSubmit
                  } > {
                    loading ? (<
                      CircularProgress />
                    ) : (<Button type="submit"
                      variant="contained"
                      color="primary"
                      className={
                        classes.submit
                      } >
                      REFERIR NUEVO COMERCIO</Button>
                      )
                  } </Grid>
              </form >
            </Paper>
          </Grid >
        </Grid>
      </div>
    );
  };
  
  export default withRouter(TellAFriend);